import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './unsupported-browser.component.html',
  styleUrls: ['./unsupported-browser.component.scss']
})
export class UnsupportedBrowserComponent {}
